<!--
 * @Author: v_hllhe
 * @Date: 2022-12-19 13:24:48
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-29 18:07:49
 * @Description:
-->
<template>
<div>
  <div class="wrap">
  <div class="image" >
    <div class="content">
      <div class="title">
        {{content.title}}
      </div>
      <div class="score" :style="{color: content.warn? '#EC4F4F':'#165BEC'}">
          <countTo :val="content.score"/>
      </div>
       <div class="rate">
        权重：{{content.rate}}%
      </div>
      <!-- <div class="monthRate">
        月环比{{content.monthRate}}
      </div> -->
    </div>
    <!-- <img src="~@/assets/polygon.png" alt=""> -->
    <div :class="{img: true, animate: content.warn? true: false}" ></div>
  </div>
   <!-- <div :class="{hexagon: true, animate: content.warn? true: false}"></div> -->
</div>
</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import countTo from '@/components/numGif';
export default {
  name: '',
  // import引入的组件需要注入到对象中才能使用
  components: {
    countTo,
  },
  props: {
    content: {
      type: Object,
      default: () => ({
        title: '有效时长评分',
        rate: '40%',
        score: '67',
        monthRate: '+10%',
        warn: true, // 是否告警（即是否有闪光动画）
      }),
    },
  },
  data() {
    // 这里存放数据
    return {
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteLeave() { // 路由离开钩子
  },
};
</script>
<style lang='scss' scoped>
@import '@/styles/convert-viewport';

@keyframes myfirst {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.wrap{
  width: vw(227);
  position: relative;

}
@keyframes blow {
  0% {
    background-image: url('~@/assets/polygon.png');
  }
  50% {
    background-image: url('~@/assets/polygonBlow.png');
  }
  100% {
    background-image: url('~@/assets/polygon.png');
  }
}
.image{
    position: absolute;
    z-index: 4;
    width: vw(227);
    height: vw(227);
    .img{
      width: 100%;
      height: 100%;
      background-image: url('~@/assets/polygon.png');
      background-size: 100% 100%;
    }
    .animate{
      // TODO
      animation: blow 2s infinite ease-in-out;
    }
    .content{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .title, .rate, .score, .monthRate{
        text-align: center;
        letter-spacing: 0;
      }
      .title {
        font-family: TencentSansW7;
        font-size: vw(18);
        color: #56688A;
        line-height: vh(26);
      }
      .rate{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: vw(14);
        color: #56688A;
        line-height: vh(22);
      }
      .score{
        font-family: TCloudNumber-Regular;
        font-weight: 400;
        font-size: vw(36);
        color: #EC4F4F;
        // color: #165BEC;
        letter-spacing: 0;
        line-height: vh(56);
        // margin-top: vh(6);
      }
      .monthRate{
        margin-top: vh(4);
        color: rgba(86, 104, 138, 1);
        font-size: vw(14);
        font-face: PingFangSC;
        font-weight: 400;
        line-height: vh(22);
      }
    }
}

 .hexagon {
  position: relative;
  border-radius: 10px;
  padding: vw(40) vw(40);
  height: vh(100);
  width: vw(145);
  // margin: vw(50);
  margin-top: vw(38);
  box-sizing: border-box;
  // border: 5px solid transparent;
  /* border-left-color: black; */
  /* border-right-color: black; */
  display: inline-block;
}

.animate, .animate:before, .animate:after{
  // animation:  glowGif 2s linear infinite;
}

.hexagon:before,
.hexagon:after {
  content: "";
  border: inherit;
  position: absolute;
  top: vh(0);
  left: vw(0);
  background: inherit;
  border-radius: inherit;
  height: 100%;
  width: 100%;
}

.hexagon:before {
  transform: rotate(60deg);
}

.hexagon:after {
  transform: rotate(-60deg);
}
@keyframes glowGif {
  0% {
       box-shadow:
            0 0 0 transparent,
            0 0 0 transparent,
  }
  50% {
    box-shadow:
    10px 0px 2px -3px rgba(255, 0, 0, 0.5),
    -10px 0px 2px -3px rgba(255, 0, 0, 0.5);
  }
  0% {
     box-shadow:
            0 0 0 transparent,
            0 0 0 transparent,
  }
}
</style>
